export default __webpack_public_path__ + "static/media/image1.c9fae8ea.webp";